module.exports = __webpack_public_path__ + "img/Dantam Hair 35.0e72bfbc.jpg";